import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { LonelinessGraphStyles } from './LonelinessGraph.styles';

export const ScreenLonelinessGraph: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Loneliness Graph',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  return (
    <LonelinessGraphStyles>
      <OnboardingNavigation />

      <IonContent>
        <OnboardingTitle className="loneliness-graph-title">
          Feeling lonely is okay
        </OnboardingTitle>
        <OnboardingSubtitle>
          Even if you’re in the relationship
        </OnboardingSubtitle>
        <div className="img-container">
          <img
            src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness_graph.png"
            alt="preferences_image"
          />
        </div>
        <div className="description">
          <UiTypography variant="title-medium" color="black">
            Odds of Premature Mortality
          </UiTypography>
          <UiTypography variant="label-small" color="neutral-black">
            Source: Holt-Lunstad J, Robles TF, Sbarra DA. <br />
            Advancing Social Connection as a
          </UiTypography>
        </div>
      </IonContent>

      <OnboardingFooter onContinue={wizard.nextStep} />
    </LonelinessGraphStyles>
  );
};
